import { render, staticRenderFns } from "./scorecard-order-old.vue?vue&type=template&id=c6834826&scoped=true"
import script from "./scorecard-order-old.vue?vue&type=script&lang=js"
export * from "./scorecard-order-old.vue?vue&type=script&lang=js"
import style0 from "./scorecard-order-old.vue?vue&type=style&index=0&id=c6834826&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6834826",
  null
  
)

export default component.exports